module.exports = __webpack_public_path__ + "static/media/cancel.1ed496b7.svg";